import { PaginationMeta } from "app/services/api/types/common/responses/PaginatedResponse";
import { Text, View } from "react-native";
import { Button, ButtonText } from "ui/gluestack/button";

interface PaginationProps {
  meta?: PaginationMeta;
  onPageChange: (page: number) => void;
}

export default function Pagination({ meta, onPageChange }: PaginationProps) {
  if (!meta) {
    return <View className="py-7"></View>;
  }
  return (
    <View className="py-2 items-center flex flex-row justify-between">
      <Text className="text-sm">
        {meta?.total ? `Page ${meta.current_page} of ${meta.last_page}` : ""}
      </Text>
      <View className="flex flex-row gap-x-3">
        <Button
          action="primary"
          variant="outline"
          disabled={meta.current_page === 1}
          onPress={() => onPageChange(meta.current_page - 1)}
        >
          {/* eslint-disable-next-line react-native/no-raw-text */}
          <ButtonText className="text-xs font-medium">Previous</ButtonText>
        </Button>
        <Button
          action="primary"
          variant="outline"
          disabled={meta.current_page === meta.last_page}
          onPress={() => onPageChange(meta.current_page + 1)}
        >
          {/* eslint-disable-next-line react-native/no-raw-text */}
          <ButtonText className="text-xs font-medium">Next</ButtonText>
        </Button>
      </View>
    </View>
  );
}
